import styles from "./index.module.css";

export default function EPLogo({ className, variant, ...rest }) {
  return (
    <>
      <div className={styles.EPlogo} {...rest}>
        <img className={styles.EPimagesLogo}
          src="/images/logo-book.png"
          alt="Logo Book"
        />
        <div className={[styles[variant] || styles.EPtextLogo, className].join(" ")}>
          <strong>ESCRITA PRÁTICA</strong>
          <small>Professora Iasmyn Souza Louis</small>
        </div>
      </div>
    </>
  );
}